(function () {
  //
  const footerData = [
    {
      title: "Products",
      data: [
        {
          title: "Script to Video",
          link: "/script-to-video/",
        },
        {
          title: "Text to Video",
          link: "/ai-video-generator/",
        },
        {
          title: "Image to Video",
          link: "/ai-video-generator/",
        },
        {
          title: "Script to Video",
          link: "/script-to-video/",
        },
        {
          title: "Reference to Video",
          link: "/ai-video-generator/",
        },
        {
          title: "AI Video Caption",
          link: "/ai-caption-generator/",
        },
        {
          title: "Kling Text to Video",
          link: "/kling-text-to-video/",
        },
      ],
    },
    {
      title: "Effects",
      data: [
        {
          title: "AI Hug",
          link: "/apps/ai-video-generator/",
        },
        {
          title: "AI Kissing",
          link: "/apps/ai-video-generator/",
        },
        {
          title: "Yesterday Once More",
          link: "/apps/ai-video-generator/",
        },
        {
          title: "Decapitate",
          link: "/apps/ai-video-generator/",
        },
        {
          title: "Eye-pop",
          link: "/apps/ai-video-generator/",
        },
        {
          title: "More",
          link: "/apps/ai-video-generator/",
          hasUnderline: true,
        },
      ],
    },
    {
      title: "Free AI Tools",
      data: [
        {
          title: "Youtube Video Downloader",
          link: "/youtube-video-downloader",
        },
        {
          title: "Youtube to MP4",
          link: "/youtube-to-mp4",
        },
        {
          title: "Youtube Shorts Downloader",
          link: "/youtube-shorts-downloader",
        },
        {
          title: "Youtube to MP3",
          link: "/youtube-to-mp3",
        },
        {
          title: "Tiktok Video Downloader",
          link: "/tiktok-video-downloader",
        },
        {
          title: "Instagram Reels Downloader",
          link: "/instagram-reels-downloader",
        },
      ],
    },
    // {
    //     title: 'Features',
    //     data: [
    //         {
    //             title: 'Sora AI Video Generator',
    //             link: 'https://vidfly.ai/sora-ai-video-generator/'
    //       }
    //   ]
    // },
    {
      title: "Resources",
      data: [
        {
          title: "Pricing",
          link: "/pricing/",
        },
        {
          title: "Blog",
          link: "/blog/",
        },
        {
          title: "Email Us",
          link: "mailto:support@vidfly.ai",
          hasUnderline: true,
        },
      ],
    },
  ];
  const footerRightWrap = document.querySelector(".unique-wrap-right");
  // const footerTitles = document.getElementsByClassName('footer-title');
  // const footerLinks = document.getElementsByClassName('footer-link');
  footerData.forEach((item, index) => {
    let isFold = true;
    const divDom = document.createElement("div");
    const titleDom = document.createElement("div");
    const linkDom = document.createElement("div");

    const spanDom = document.createElement("span");
    spanDom.textContent = item.title;
    titleDom.appendChild(spanDom);

    // h5
    if (document.documentElement.clientWidth < 768) {
      const img = document.createElement("img");
      img.src =
        "https://vidfly-02.oss-us-east-1.aliyuncs.com/blog/images/downWhite.svg";
      titleDom.appendChild(img);
      titleDom.addEventListener("click", () => {
        if (isFold) {
          linkDom.classList.add("footer-link-active");
        } else {
          linkDom.classList.remove("footer-link-active");
        }
        isFold = !isFold;
      });
    }
    titleDom.classList.add("footer-title");
    linkDom.classList.add("footer-link");
    item.data.forEach((itm, idx) => {
      const a = document.createElement("a");
      a.textContent = itm.title;
      a.href = itm.link;
      linkDom.appendChild(a);
      if (itm.hasUnderline) {
        a.style.textDecoration = "underline";
      }
    });
    divDom.appendChild(titleDom);
    divDom.appendChild(linkDom);
    footerRightWrap.appendChild(divDom);
  });
})();
